var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBotonExamen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 340,
    height: 135,
    viewBox: "0 0 340 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_43_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 41C29 36.5817 32.5817 33 37 33H292C296.418 33 300 36.5817 300 41V94C300 98.4183 296.418 102 292 102H37C32.5817 102 29 98.4183 29 94V41Z",
    fill: "url(#paint0_linear_43_1524)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136.313 76V73.52H129.713V70.06H135.333V67.58H129.713V64.24H136.313V61.76H126.933V76H136.313ZM149.343 76L144.903 68.7L149.043 61.76H145.903L143.403 66.36L140.923 61.76H137.763L141.903 68.7L137.483 76H140.663L143.403 71.04L146.163 76H149.343ZM162.094 76L156.894 61.76H154.714L149.534 76H152.434L153.294 73.48H158.354L159.194 76H162.094ZM157.614 71.14H154.074L155.874 65.96L157.614 71.14ZM158.694 56.98H155.954L154.674 60.38H156.414L158.694 56.98ZM176.748 76V61.76H174.008L170.308 69.46L166.588 61.76H163.848V76H166.628V67.7L169.368 73.1H171.248L173.968 67.7V76H176.748ZM189.438 76V73.52H182.838V70.06H188.458V67.58H182.838V64.24H189.438V61.76H180.058V76H189.438ZM203.068 76V61.76H200.288V70.48L194.648 61.76H192.168V76H194.948V67.26L200.588 76H203.068Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_43_1524",
    x: 4,
    y: 14,
    width: 321,
    height: 119,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0603645 0 0 0 0 0.372425 0 0 0 0 0.7625 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_43_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_43_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_43_1524",
    x1: 142.515,
    y1: -7.58823,
    x2: 119.002,
    y2: 99.6986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#549DF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1766C9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotonExamen);
export default __webpack_public_path__ + "static/media/botonExamen.514e11bf5a769b0603edc8b2a833b566.svg";
export { ForwardRef as ReactComponent };